import { useMemo } from 'react';
import { useCustomMask } from '@direct-frontend/components';

export const usePatternMask = () => {
    const urlMaskProps = useMemo(() => {
        return {
            mask: new RegExp(
                "^((?:[а-яА-ЯёЁa-zA-Z0-9\-._~!$'+@]|%[0-9A-Fa-f]{2})+)(\/((?:[а-яА-ЯёЁa-zA-Z0-9\-._~!$'+@]|%[0-9A-Fa-f]{2})+))*\/?$"
            ),
            transformToUnmasked: (value: string) => value,
        };
    }, []);

    return useCustomMask(urlMaskProps);
};
